import { useEffect, useState, useCallback } from "react";
import Navbar from "./Navbar.component";
import StoreChat from "../components/StoreChat.component";
import EventBus from "../common/EventBus";
import { Outlet } from "react-router-dom";
import { useLogout } from "../hooks/useLogout";
import useVerifyJwt from "../hooks/useVerifyJwt";

function Applayout() {
  const { logout } = useLogout();
  const { isExpire } = useVerifyJwt();
  const [chatOpen, setChatOpen] = useState(false);

  const toggleChat = useCallback(() => setChatOpen((prev) => !prev), []);
  const closeChat  = useCallback(() => setChatOpen(false), []);

  useEffect(() => {
    EventBus.on("logout", () => {
      logout();
    });

    if (isExpire) {
      logout();
    }

    return () => {
      EventBus.remove("logout");
    };
  }, [logout, isExpire]);

  return (
    <div>
      <Navbar logOut={logout} onToggleChat={toggleChat} />
      <main className="app-content">
        <Outlet />
      </main>

      {/* Floating chat button */}
      <button className="chat-fab" onClick={toggleChat} title="Ask AI">
        {chatOpen ? "✕" : "🤖"}
      </button>

      {/* Slide-out chat drawer */}
      <StoreChat open={chatOpen} onClose={closeChat} />
    </div>
  );
}

export default Applayout;
